<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WFDetector
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WFDetector</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">WMDS</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WFDetector
      </template> -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col>
            <b-form-group label="검색할 솔루션">
              <b-form-radio-group id="radio-group-1" v-model="search_type" v-b-tooltip.hover title="Please enter the Usage Status you want to search for">
                <b-form-radio value="wmds" @click="so.sv=`wmds`">WMDS</b-form-radio>
                <b-form-radio value="wsfinder" @click="so.sv=`wsfinder`">WSFinder</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="search_type == 'wsfinder'" @click="so.skt = 'action'">
          <b-col>
            <b-form-group label="Usage status">
              <b-form-radio-group id="radio-group-2" v-model="action_type" v-b-tooltip.hover title="Please enter the Usage Status you want to search for">
                <b-form-radio value="Delete" >삭제</b-form-radio>
                <b-form-radio value="Remove" >삭제</b-form-radio>
                <b-form-radio value="Create" >생성</b-form-radio>
                <b-form-radio value="Modified" >수정</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            시작일
            <b-form>
              <date-picker v-model="so.opt.created_at_sd" :lang="custom.lang.ko" style="width: 60%" :confirm="true" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            종료일
            <b-form>
              <date-picker v-model="so.opt.created_at_ed" :lang="custom.lang.ko" style="width: 60%" :confirm="true" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > 검색 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> 닫기 </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col md="6">
          <select v-model="limit" @change="$refs._list.refresh()">
            <option disabled value="20">화면에 표시 수 선택하세요 : 기본 20</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col md="6">
          <select v-model="search_type" @change="$refs._list.refresh()">
            <option disabled value="">타입을 선택하세요</option>
            <option value="wmds">WMDS : 웹 악성코드 탐지 시스템</option>
            <option value="wsfinder">WSFinder : 웹쉘 파인더</option>
          </select>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          <b-input-group size="sm">
            <b-form inline>
              <span class="mr-2">검색 기간</span>
              <date-picker @change="refresh" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang[i18n.toLowerCase()]" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang[i18n.toLowerCase()]" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group size="sm" >
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <!-- <b-dropdown-item v-if="search_type == 'wsfinder'" size="sm" @click="so.sk='';so.skt='action'">Action</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt='공격대상'">공격대상</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <!-- <select v-if="so.skt == 'action'" v-model="action_type" @change="$refs._list.refresh()">
              <option disabled value="">Please select action</option>
              <option value="Delete">Delete</option>
              <option value="Remove">Remove</option>
              <option value="Create">Add</option>
              <option value="Modified">Modified</option>
            </select> -->
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn v-if="so.skt != 'action'" variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv; so.sv = ''"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 상세검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="agent" slot-scope="row">
          <span v-if="row.item.type && row.item.type.toUpperCase() == 'WMDS'">
            {{row.item.site.fqdn}}
            <span v-if="row.item.site.fqdn != row.item.site.name">[ {{ row.item.site.name }} ]</span>
          </span>
          <span v-else>
            {{row.item.agent.name}}
            <span v-if="row.item.agent.name != row.item.agent.host">[ {{row.item.agent.host}} ]</span>
          </span>
        </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="action" slot-scope="row">
          <b-badge variant="warning" v-if="row.item.action && row.item.action.toUpperCase() == 'MODIFIED HASH'">{{row.item.action}}</b-badge>
          <span v-else>{{row.item.type.toUpperCase() != 'WMDS' ? codes.agent_forgery[row.item.action] || row.item.action : "Changed"}}</span>
          <b-button size="sm" v-if="row.item.type.toUpperCase() == 'WMDS'" variant="success" @click="detail(row.item)">More</b-button>
        </template>
        <!-- <template slot="target" v-if="row.item.type.toUpperCase() == 'WMDS'" slot-scope="row">{{row.item.target}}</template> -->
        <template slot="target" slot-scope="row">
          <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target}}</span>
          <span v-else-if="row.item.target_type">
            [{{row.item.target_type}}]
            <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
              {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
            </span>
            <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
              {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
            </span>
          <span v-else>
            {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
          </span>
          {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
        </span>
        <span v-else>
          {{row.item.target}}
        </span>
        </template>
      </b-table>

      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="model && model.id">
      <div slot="header">
				<strong>{{model.target}}</strong>
        <span class="float-right">{{model.created_at | sdate}}</span>
			</div>
      <!-- <b-form-group>
        <label for="ph_title">URL</label>
        <pre id="ph_content">{{model.target}}</pre>
      </b-form-group> -->
      <b-form-group>
        <!-- <label for="ph_content">Content</label> -->
        <pre id="ph_content">{{model.now_snapshot}}</pre>
        <!-- <b-form-textarea :rows="3" v-model="model.content" id="ph_content"></b-form-textarea> -->
      </b-form-group>
    </b-card>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="기간 설정" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      시작 날짜 및 마지막 날짜를 지정해야 조회가 가능합니다.
    </b-modal>

     <!-- 기간 설정 범위제한 모달-->
     <b-modal title="기간 설정" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      결과 목록은 최대 1년단위로 조회가 가능합니다.
    </b-modal>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
